import { useQuery } from 'react-query';
import { marketingProjectService } from 'services';
import { ServerStateKeysEnum } from '../../constants';

export const useFetchMarketingProjectDetailsByProjectId = (
  projectId: string
) => {
  const cacheKey = [ServerStateKeysEnum.marketingProjects, projectId];
  return useQuery(
    cacheKey,
    () => {
      return marketingProjectService.getProjectDetailsByProjectId(projectId);
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};
